import { render, staticRenderFns } from "./storeManage.vue?vue&type=template&id=beaa53e8&scoped=true&"
import script from "./storeManage.vue?vue&type=script&lang=js&"
export * from "./storeManage.vue?vue&type=script&lang=js&"
import style0 from "./storeManage.vue?vue&type=style&index=0&id=beaa53e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa53e8",
  null
  
)

export default component.exports